import { createApp } from 'vue';
import TradeArea from './src/components/TradeArea.vue';
import TradeAreaWC from './src/components/TradeAreaWC.vue';
import './assets/scss/main.scss';
import 'ion-rangeslider/css/ion.rangeSlider.css';
import { store } from './src/store';
import { createRouter } from './src/router';
const tradearea = document.querySelector('#trade-area');
const wc = document.querySelector('#trade-area--wc');
if (tradearea !== null) {
    const vm = createApp(TradeArea);
    vm.use(store);
    vm.use(createRouter());
    vm.mount(tradearea);
}
else if (wc !== null) {
    const vm = createApp(TradeAreaWC, {
        brand: wc.getAttribute('brand') || null,
        category: wc.getAttribute('category') || null,
    });
    vm.use(store);
    vm.mount(wc);
}
